module.exports = __webpack_public_path__ + "static/media/Program3.b993a526.jpg";